// extracted by mini-css-extract-plugin
module.exports = {"previewWrapper":"preview-wrapper__previewWrapper--3366Z","downloadButton":"preview-wrapper__downloadButton--39kEu"};